import { HELP_CENTER_HOME } from '@utils/helpLink'

export const INVOICE_HELP_CENTER_URL =
  import.meta.env.DOCUMENT_URL || HELP_CENTER_HOME
export const FORDEER_APPS_URL = 'https://apps.fordeercommerce.io/'
